export enum AuctionStatus {
  NoBids = 1,
  UserNotBid = 2,
  UserWinning = 3,
  UserLosing = 4
}
